import { t } from '@/plugins/i18n'
import { nextTick, ref, toRaw } from 'vue'
import { formatCommonProduct } from './useCommonProduct'
import { searchUrl, productDetail } from '@/apis/search'
import { useRoute } from 'vue-router'

const formatCommonProductSku = (data: any, rate: number) => {
  const productName = data.productTitle
  const platformType = data.platformType
  return (data.skuList || []).map((v: any) => ({
    ...v,
    id: v.productSku,
    code: v.productCode,
    name: productName,
    type: platformType,
    img: v.productSkuImg || data.productMainImg,
    PropertiesName: v.productPropertiesName,
    price: v.productSellPrice ?? 0,
    PriceJpy: (v.productSellPrice ?? 0) * rate ? Math.floor((v.productSellPrice ?? 0) * rate) : 0,
    productCategoryFrontendFirstNameJp: data.productCategoryFrontendFirstNameJp,
    productCategoryFrontendSecondNameJp: data.productCategoryFrontendSecondNameJp
  }))
}

export default (productCode: any, keyword: any, rate: any, emits: any) => {
  const list: any = ref([])
  const loading: any = ref(false)
  const route = useRoute()
  const getList = () => {
    if (productCode.value) {
      loading.value = true
      emits('update:skuLoading', true)
      productDetail({ productCode: productCode.value }).then(res => {
        list.value = formatCommonProductSku(res.data, rate.value)
        nextTick(() => {
          emits('update:skuList', list.value)
        })
      }).finally(() => {
        loading.value = false
        emits('update:skuLoading', false)
      })
      return
    } else if (keyword.value) {
      const kw = keyword.value.trim()
      loading.value = true
      emits('update:skuLoading', true)
      searchUrl({ detailUrl: kw }).then(res => {
        if (res.success) {
          list.value = formatCommonProductSku(res.data, rate.value)
          nextTick(() => {
            emits('getData', formatCommonProduct(res.data, rate.value))
            emits('getSkuData', res.data.productCode)
            emits('update:skuList', list.value)
          })
        } else {
          nextTick(() => {
            emits('error')
          })
        }
      }).finally(() => {
        loading.value = false
        emits('update:skuLoading', false)
      })
      return
    }
    if (route.query?.productCode) {
      loading.value = true
      emits('update:skuLoading', true)
      productDetail({ productCode: route.query.productCode } as any).then(res => {
        list.value = formatCommonProductSku(res.data, rate.value)
        nextTick(() => {
          emits('getData', formatCommonProduct(res.data, rate.value))
          emits('getSkuData', res.data.productCode)
          emits('update:skuList', list.value)
        })
      }).finally(() => {
        loading.value = false
        emits('update:skuLoading', false)
      })
    }
  }

  return [
    loading,
    list,
    getList
  ]
}
